import { createRoot } from 'react-dom/client';
import React from 'react';
import App from './App';

async function initMockApiWorker() {
    if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_ENABLE_MOCK_API) {
        const { mockApiWorker } = await import('./mocks/browser');
        return mockApiWorker.start({
            onUnhandledRequest: 'bypass',
        });
    }

    return Promise.resolve();
}

initMockApiWorker().then(() => {
    const rootContainer = document.getElementById('root');
    if (!rootContainer) throw new Error('Root container not found!');

    const root = createRoot(rootContainer);
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
});
